import { AutoMap } from '@automapper/classes';

export class MeasureEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    Status!: number;
    @AutoMap()
    Observation!: string;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    MeasureReferenceCode!: string;
    @AutoMap()
    MeasureReferenceName!: string;
    @AutoMap()
    Color!: string;
    @AutoMap()
    TextColor!: string;
    @AutoMap()
    PumpWithBattery!: boolean;
    @AutoMap()
    HasFan!: boolean;
    @AutoMap()
    IsDepose!: boolean;
    CassetteId?: number;
    PoseSecuriteId?: number;
    DePoseSecuriteId?: number;
    SamplingConditionId?: number;
}
